import {Box, Container} from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import {makeStyles} from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'

import {useHistory} from 'react-router-dom'
import logo from '../assets/recoverypad_logo.png'
import suha from '../assets/chatbot.svg'
import badge from '../assets/hippa_badge.png'

import WelcomeButton from './Common/ButtonWhiteBlue'

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.primary.dark,
        padding: '5vh 5vw',
    },
    footer: {
        backgroundColor: "#256081",
        padding: '0',
        color: "white",
        bottom: 0
    },
    logo: {
        maxWidth: '80vw',
    },
    body1: {
        colorTextPrimary: {
            color: 'red',
            backgroundColor: 'red',
        },
    },
    suha: {
        margin: '5vh',
        maxWidth: '40vw',
    },
    gridContainer: {},
}))

export default function Welcome() {
    const classes = useStyles()

    const history = useHistory()

    const handleRegister = () => {
        history.push('/register')
    }

    const handleLogin = () => {
        history.push('/signin')
    }

    return (
        <div style={{display:"flex", flexDirection:"column", justifyContent:"space-between", height:"100vh"}}>
            <Container className={classes.root}>
                <Grid
                    item
                    xs={12}
                    container
                    className={classes.gridContainer}
                    alignItems="center"
                    direction="column"
                >
                    <Grid item xs={12} container alignItems="center" direction="column">
                        <Grid item sm={12} xs={12} >
                            <span style={{position:"absolute", top: 70, fontSize: 22}}>Welcome to</span>
                            <img src={logo} className={classes.logo} alt="logo"/>
                        </Grid>
                        <Grid item sm={12} xs={12} container alignContent={"center"} alignItems={"center"} >
                            <Grid item sm={6} xs={12} alignItems={'center'} justifyContent={'center'} justify={'center'} style={{display: "flex"}}>
                                <img src={suha} className={classes.suha} alt="logo"/>
                            </Grid>
                            <Grid item sm={6} xs={12} container alignContent={"center"}>
                                <Grid  item xs={12}>
                                    <WelcomeButton label="Register" handleClick={handleRegister}/>
                                </Grid>
                                <Grid  item xs={12}>
                                    <WelcomeButton label="Log In" handleClick={handleLogin}/>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <br/>

                </Grid>
            </Container>
            <Container className={classes.footer}>
                <Grid
                    item
                    xs={12}
                    container
                    className={classes.gridContainer}
                    alignItems="center"
                    direction="column"
                >
                    <Grid item xs={12}>
                        <Box mx="auto" pt={4} pb={2}>
                            <Typography variant="caption">
                                © {new Date().getFullYear()} Recoverypad. All Rights Reserved.
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Box mx="auto" px={5}>
                            <Typography variant="caption" align="center">
                                If you are in crisis or a life threatening situation, do NOT use
                                this site. Call the 24-hour National Suicide Prevention Lifeline at 988. Your call will
                                be routed to the crisis center
                                near you. If your issue is an emergency, call 911 and/or go to
                                your nearest emergency department.​
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid container alignItems="center" justify="space-around">
                        <Grid item>
                            <Box mx="auto" my={2}>
                                <img src={badge} alt="logo"/>
                            </Box>
                        </Grid>
                        <Grid item>
                            <Grid container alignItems="center" justify="space-around">
                                <Grid item>
                                    <a href="/privacy-policy" target="_blank" style={{color: "white"}}>
                                        Privacy Policy
                                    </a>
                                </Grid>
                                &nbsp;|&nbsp;
                                <Grid item>
                                    <a href="/terms-conditions" target="_blank" style={{color: "white"}}>
                                        Terms & Conditions
                                    </a>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                </Grid>
            </Container>
        </div>
    )
}
